import React, { useState, useEffect, useRef, useMemo } from 'react';
import styled from 'styled-components';
import LightButton from '~/editor/buttons/LightButton';
import ArrowIcon from '~/assets/button/arrow.svg';
import UploadIcon from '~/assets/button/upload.png';
import AllAudiosIcon from '~/assets/button/all_audios.png';
import AiIcon from '~/assets/button/ai_b.png';
import { useEditorStore } from '~/shell/Store';
import SmallButton from '~/editor/buttons/SmallButton';
import { useToastStore } from '~/ui/toast/toastStore';
import { ToastSeverity } from '~/ui/toast/types';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { TrashIconForBtn } from '~/training/sequence/templates/items';
import CircleLoader from '~/editor/loader/CircleLoader';
import NoImageIcon from '~/assets/icons/no_image.svg';
import AudioIcon from '~/assets/icons/uploadAudio.svg';
import VoiceItem from './VoiceItem';
import { useMessageStore } from '~/editor/store/messageStore';

export const UploadAudioIcon = styled(AudioIcon)``;

const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  perspective: 1000px;
  z-index: 500;
  background: #000000b0;
`;

const Wrapper = styled.div`
  flex: 1;
  display: flex;

  .closeBtn {
    margin-left: calc(100% - 70px);
    margin-top: -13px;
  }

  .left {
    width: 250px;
    padding-right: 20px;

    h3 {
      font-family: ralewayBold;
      font-size: 14px;
      line-height: 16.44px;
      letter-spacing: 0.1em;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }

    ul {
      margin-top: 20px;
      li {
        padding: 8px;
        font-family: Raleway;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        cursor: pointer;

        display: flex;
        justify-content: space-between;
        padding-left: 36px;

        svg {
          rotate: 180deg;
          margin-top: 5px;
          path {
            fill: #e0e0e0;
          }
        }
      }
      li.active {
        border-radius: 8px;
        background: #f5f5f5;

        svg {
          path {
            fill: #000;
          }
        }
      }
      li.all_narrations {
        background-image: url(${AllAudiosIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
      }
      li.upload {
        background-image: url(${UploadIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
      }
      li.ai {
        background-image: url(${AiIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
      }
    }
  }
  .right {
    h3 {
      font-family: ralewayBold;
      font-size: 16px;
      line-height: 24px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
    .header {
      border-bottom: 1px solid #d9d9d9;
      margin-bottom: 20px;
      padding-bottom: 20px;
      display: flex;
      flex-direction: row;

      button {
        background: #9738ff;
        color: #fff;
        cursor: pointer;
        font-size: 14px;
        font-family: Raleway;
        font-weight: 700;
        margin-right: 10px;
      }

      p {
        padding-left: 20px;

        font-family: Raleway;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: #6f6f6f;
      }
    }
    .header.upload {
      display: flex;
      flex-direction: row;

      align-items: center;

      background: #f8f1ff;
      border-radius: 10px;
      padding: 16px;
      border: 1px dashed #9738ff;
      transition: opacity 0.2s ease;

      &.hover {
        opacity: 0.7;
      }

      &.drag-over {
        opacity: 0.5;
        background: #f0e6ff;
        border-color: #7a2db8;
      }

      .icon {
        height: 55px;
        pointer-events: none;

        svg {
          margin-top: -14px;
        }
      }

      button {
        background: transparent;
        border: 2px solid #9738ff;
        color: #9738ff;
        border-radius: 8px;
        height: 38px;
        cursor: pointer;
        font-family: ralewayBold;
      }

      .text {
        flex: 1;
        padding-left: 10px;
        pointer-events: none;

        b {
          font-family: Raleway;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0%;
          color: #000000;
        }

        p {
          padding-left: 0px;
          font-family: Raleway;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0%;
          color: #6f6f6f;
        }
      }
    }
    .no_results {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      justify-content: center;
      flex: 1;
      height: 330px;
      width: 840px;

      p {
        font-family: Raleway;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
        text-align: center;
        color: #2e2e2e;
      }
    }
    .audios {
      display: flex;
      gap: 5px;
      flex-wrap: wrap;
      overflow-y: auto;
      max-height: 330px;
      flex-direction: row;
      width: 840px;

      .weNeedToLoad {
        height: 30px;
      }

      .audio_name {
        font-family: Raleway;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
      }

      .audio_item {
        display: flex;
        flex-direction: row;
        gap: 10px;
        width: 100%;

        audio {
          flex: 1;
          margin-right: 10px;
        }

        button {
          height: 32px;
          margin-top: 10px;
          margin-right: 5px;
        }
      }

      img {
        width: 268.69px;
        height: 162.7px;
        cursor: pointer;
        border: 1px solid transparent;
        border-radius: 5.47px;
      }

      img:hover {
        filter: brightness(0.8);
        cursor: pointer;
      }

      .selected {
        border: 1px solid #9738ff;
      }
    }
    .audios.small {
      max-height: 300px;
    }
    .audios.long {
      max-height: 430px;
    }

    .ai_container {
      display: flex;
      flex-direction: row;
      gap: 20px;
      height: 430px;

      .ai_left {
        flex: 1;

        .search_voice {
          margin-top: 10px;
          margin-bottom: 10px;

          input {
            height: 42px;
            width: 100%;
            padding: 10px 15px;
            border-radius: 5px;
            background: #f5f5f5;

            color: #6f6f6f;
            font-family: Raleway;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;

            &::placeholder {
              color: #6f6f6f;
            }
          }
        }

        .voice_list {
          display: flex;
          flex-direction: column;
          gap: 10px;
          max-height: 330px;
          overflow-y: auto;

          .voice_item {
            display: flex;
            flex-direction: row;
            padding: 3px 6px;
            cursor: pointer;

            .name {
              display: flex;
              flex: 1;
              flex-direction: column;
              gap: 2px;
            }

            b {
              font-family: Raleway;
              font-weight: 700;
              color: #2e2e2e;
              font-size: 14px;
              font-style: normal;
              line-height: 150%;
            }

            p {
              color: #2e2e2e;
              font-family: Raleway;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
            }

            .icon {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-top: 1px;
              margin-right: 10px;
            }
          }

          .selected {
            border-radius: 8px;
            background: #f5f5f5;
          }

          .voice_list_title {
            color: #2e2e2e;
            font-family: Raleway;
            font-weight: 700;
            font-size: 12px;
            font-style: normal;
            line-height: 150%;
          }
        }
      }

      .ai_right {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-bottom: 14px;

        button {
          width: fit-content;
          height: 36px;
          margin-top: 6px;
          background-color: #9738ff;
          color: #fff;
          font-family: ralewayBold;
          text-align: center;
          font-size: 14px;
          font-style: normal;
          line-height: 150%;
        }

        textarea {
          flex: 1;
          resize: none;
          padding: 10px 15px;
          border-radius: 5px;
          font-family: Raleway;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          height: 330px;
          min-height: 330px;
        }

        .re_generate_btn {
          background: #f8f1ff;
          color: #9738ff;
        }
      }
    }
    .ai_container.without_footer {
      height: 480px;

      .voice_list {
        max-height: 380px;
      }
    }
    .ai_footer {
      display: flex;
      flex-direction: row;
      gap: 10px;
      margin-left: -250px;
      margin-top: -6px;

      button {
        margin-left: auto;
        height: 36px;
        margin-top: 6px;
        background-color: #9738ff;
        color: #fff;
        font-family: ralewayBold;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        line-height: 150%;
      }

      .text {
        display: flex;
        flex-direction: column;

        b {
          font-family: ralewayBold;
          color: #000;
          font-size: 10px;
          font-style: normal;
          line-height: 150%;
          text-transform: uppercase;
        }

        p {
          overflow: hidden;
          color: #000;
          font-family: Raleway;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          height: 20px;
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        span {
          color: #000;
          font-family: Raleway;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;

          b {
            color: #9738ff;
          }
        }
      }

      .audio_preview {
        width: 100%;

        audio {
          height: 48px;
          width: 100%;
        }
      }
    }
  }
`;

const Popup = styled.div`
  background-color: #fff;
  width: 80%;
  min-width: 1090px;
  max-width: 1140px;
  height: 510px;
  border-radius: 16px;
  padding: 24px;
  position: relative;
  margin: 100px auto;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  z-index: 9999;

  h2 {
    text-align: center;
  }
`;

interface Voice {
  voice_id: string;
  voiceId?: string;
  name: string;
  gender: string;
  id?: number | string;
  previewUrl?: string;
  mediaUrl?: string;
  tags?: string[];
  script?: string;
}

const NarrationPopup = ({
  onClose,
  id,
  skipUpdate,
  onSelectCallback,
  defaultText,
  skipSequenceNarration,
  subitemId,
  clearSubitemAudio = false
}: {
  onClose: () => void;
  id?: string;
  skipUpdate?: boolean;
  onSelectCallback?: (audio: any) => void;
  defaultText?: string;
  skipSequenceNarration?: boolean;
  subitemId?: string | number;
  clearSubitemAudio?: boolean;
}) => {
  const {
    apiService,
    sequence,
    setNarration,
    updateSequence,
    updateSequenceInStore
  } = useEditorStore();
  const [textForBtn, setTextForBtn] = useState('Generating');
  const [generation, setGeneration] = useState(false);
  const [selectedVoice, setSelectedVoice] = useState<string>('');
  const [defaultVoice, setDefaultVoice] = useState<Voice>();
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState<string>(defaultText || '');
  const [voices, setVoices] = useState<Voice[]>([]);
  const [textForUploading, setTextForUploading] = useState('Uploading');
  const [uploading, setUploading] = useState(false);
  const [generatedVoices, setGeneratedVoices] = useState<Voice | null>(null);
  const [audios, setAudios] = useState<any[]>([]);
  const [canWeUpdatePage, setCanWeUpdatePage] = useState(true);
  const [disableGenerate, setDisableGenerate] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const weNeedToLoadRef = useRef<HTMLDivElement | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [newNarration, setNewNarration] = useState<Voice | null>(null);
  const [hasSwitchedToUpload, setHasSwitchedToUpload] =
    useState<boolean>(false);

  const fileElRef = useRef<HTMLDivElement>(null);

  const audioPlayersRef = useRef<Map<string, HTMLAudioElement>>(new Map());

  const stopAllAudioPlayersExcept = (exceptVoiceId?: string) => {
    audioPlayersRef.current.forEach((audioElement, voiceId) => {
      if (voiceId !== exceptVoiceId && audioElement) {
        audioElement.pause();
        audioElement.currentTime = 0;
      }
    });
  };

  const registerAudioPlayer = (
    voiceId: string,
    audioElement: HTMLAudioElement
  ) => {
    audioPlayersRef.current.set(voiceId, audioElement);
  };

  const unregisterAudioPlayer = (voiceId: string) => {
    audioPlayersRef.current.delete(voiceId);
  };

  const [menu, setMenu] = useState([
    { title: 'Generate Speech', active: true, className: 'ai' },
    { title: 'Upload Voice File', active: false, className: 'upload' }
  ]);

  const [activeMenu, setActiveMenu] = useState(menu[0].className);

  // Reset the switch flag when component mounts
  useEffect(() => {
    setHasSwitchedToUpload(false);
  }, []);

  useEffect(() => {
    const activeMenu = menu.find(item => item.active);
    setActiveMenu(activeMenu?.className || menu[0].className);
    setPage(1);
    setCanWeUpdatePage(true);
    setAudios([]);
    setGeneratedVoices(null);
  }, [menu]);

  useEffect(() => {
    if (canWeUpdatePage) {
      setLoading(true);
    }

    if (apiService && activeMenu == 'upload' && canWeUpdatePage) {
      setCanWeUpdatePage(false);
      apiService.getMedia('audios', page, 'uploaded').then(res => {
        setCanWeUpdatePage(false);
        if (res && res.audios && res.audios.length > 0) {
          setAudios(prevFiles => [...prevFiles, ...res.audios]);
          setCanWeUpdatePage(true);
        }
        setLoading(false);
      });
    }
  }, [activeMenu, apiService, page]);

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      onClose();
    }
  };

  const handlePopupKeyDown = (event: React.KeyboardEvent) => {
    // Stop all keyboard events from bubbling up to parent components
    event.stopPropagation();

    // Handle Escape key for closing
    if (event.key === 'Escape') {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setLoading(true);

    const findAudioById = (items: any[], targetId: number | string): any => {
      for (const item of items) {
        // Search in audios array
        if (item.audios && Array.isArray(item.audios)) {
          const foundAudio = item.audios.find(
            (audio: any) => audio.id == targetId
          );
          if (foundAudio) return foundAudio;
        }
        // Search in nested items
        if (item.items && Array.isArray(item.items)) {
          const found = findAudioById(item.items, targetId);
          if (found) return found;
        }
      }
      return null;
    };

    if (apiService) {
      Promise.all([
        apiService.getVoiceForSequence(sequence.id),
        apiService.getPreferredVoice(),
        apiService.getVoices()
      ])
        .then(([voiceRes, preferredVoiceRes, voicesRes]) => {
          // Handle voice for sequence response
          // Skip loading sequence narration when skipSequenceNarration is true
          // This is used for subitem audio to prevent showing sequence narration
          if (
            voiceRes &&
            voiceRes.audios &&
            voiceRes.audios[0] &&
            !skipSequenceNarration
          ) {
            setGeneratedVoices(voiceRes.audios[0]);

            // Only set the input text from the server-provided script when
            // the caller hasn't provided a defaultText. This lets callers
            // prefill the textarea without the API overwriting it.
            if (voiceRes.audios[0].script && !defaultText) {
              setText(voiceRes.audios[0].script);
              setSelectedVoice(voiceRes.audios[0]?.voiceId);
            }
          }

          // Handle preferred voice response
          if (preferredVoiceRes && preferredVoiceRes.voice) {
            setDefaultVoice(preferredVoiceRes.voice);
            if (preferredVoiceRes.voice.voiceId) {
              setSelectedVoice(preferredVoiceRes.voice.voiceId);
            }
          }

          // Set selected voice from sequence narration
          // Skip this when skipSequenceNarration is true to avoid using sequence voice
          if (
            voiceRes &&
            voiceRes.audios &&
            voiceRes.audios[0] &&
            voiceRes.audios[0].voiceId &&
            !skipSequenceNarration
          ) {
            const voice = voicesRes.voices.find(
              (voice: any) => voice.voiceId == voiceRes.audios[0].voiceId
            );

            if (voice) {
              setSelectedVoice(voice.voiceId);
            } else {
              setSelectedVoice(voicesRes.voices[0].voiceId);
            }
          }

          // Handle voices response
          if (voicesRes && voicesRes.voices) {
            setVoices(voicesRes.voices);
          }

          // Handle subitem audio loading by id
          if (id) {
            const audio = findAudioById(sequence.items || [], id);
            if (audio) {
              setGeneratedVoices(audio);

              if (audio.script) {
                setText(audio.script);
                setSelectedVoice(audio.voiceId);
              }
            }
          } else if (skipSequenceNarration) {
            // When skipSequenceNarration is true and no id exists,
            // clear generatedVoices to prevent showing stale data from previous modal opens
            setGeneratedVoices(null);
          }

          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          console.error('Error loading data:', error);
        });
    }
  }, [menu, id]);

  // Switch to upload tab if generatedVoices has no voiceId and we haven't switched yet
  useEffect(() => {
    if (generatedVoices && !generatedVoices.voiceId && !hasSwitchedToUpload) {
      setMenu(
        menu.map(i => ({
          ...i,
          active: i.className == 'upload'
        }))
      );
      setHasSwitchedToUpload(true);
    }
  }, [generatedVoices, hasSwitchedToUpload]);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (uploading) {
      interval = setInterval(() => {
        setTextForUploading(prev => {
          if (prev === 'Uploading...') {
            return 'Uploading';
          }
          return prev + '.';
        });
      }, 250);
    } else {
      setTextForUploading('Uploading');
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [uploading]);

  const onGenerateNarration = () => {
    setLoading(true);
    setGeneration(true);
    setDisableGenerate(true);

    apiService?.generateNarration(text, selectedVoice, 'en').then(res => {
      setDisableGenerate(false);
      setGeneration(false);
      setLoading(false);

      if (res && res.audio) {
        setAudios([res.audio, ...audios]);
        setNewNarration(res.audio);

        useMessageStore.getState().setShowMessage(true);
        useMessageStore
          .getState()
          .setMessage('New narration has been generated');
      } else {
        useToastStore.getState().add({
          severity: ToastSeverity.Error,
          message: res.message
        });
      }
    });
  };

  const getVoiceName = (voiceId: string | undefined) => {
    if (voiceId) {
      const voice = voices.find(voice => voice.voiceId == voiceId);
      return voice?.name;
    }
    return '';
  };

  const onSelectNarration = (audio: any) => {
    if (skipUpdate) {
      onSelectCallback?.(audio);
      return;
    }

    if (!sequence.narration) {
      useMessageStore.getState().setShowMessage(true);
      useMessageStore.getState().setMessage('New narration has been applied');
    }

    setNarration(
      audio.mediaUrl == sequence.narration ? { id: '', mediaUrl: '' } : audio
    );
    onClose();
  };

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (generation) {
      interval = setInterval(() => {
        setTextForBtn(prev => {
          if (prev === 'Generating...') {
            return 'Generating';
          }
          return prev + '.';
        });
      }, 250);
    } else {
      setTextForBtn('Generating');
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [generation]);

  const uploadFileToTheServer = (file: File) => {
    setUploading(true);
    const _type = 'audio';

    if (file) {
      apiService?.uploadMedia('audios', file).then(res => {
        setUploading(false);

        if (res.error) {
          setUploading(false);

          useToastStore.getState().add({
            severity: ToastSeverity.Error,
            message: res.message
          });
        } else {
          if (res && res[_type]) {
            setAudios(prevImages => [res[_type], ...prevImages]);
          }
        }
      });
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      uploadFileToTheServer(file);
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove('drag-over');
    const file = event.dataTransfer.files[0];

    if (file) {
      uploadFileToTheServer(file);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.add('drag-over');
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove('drag-over');
  };

  const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
    event.currentTarget.classList.add('hover');
  };

  const handleMouseLeave = (event: React.MouseEvent<HTMLDivElement>) => {
    event.currentTarget.classList.remove('hover');
  };

  const onRemoveAudio = (id: number) => {
    if (apiService) {
      apiService.deleteMedia(id, 'audios').then(res => {
        if (res.error) {
          useToastStore.getState().add({
            severity: ToastSeverity.Error,
            message: res.message
          });
        } else {
          setAudios(audios.filter(audio => audio.id !== id));
          setGeneratedVoices(
            generatedVoices?.id !== id ? generatedVoices : null
          );
        }
      });
    }
  };

  const DeselectNarration = (id: number) => {
    if (clearSubitemAudio && subitemId) {
      updateSequence(subitemId, 'audio_ids', []);
      updateSequenceInStore(subitemId, 'feedbackAudios', null);
    }

    if (skipUpdate) {
      onSelectCallback?.(null);
      return;
    }

    setNarration({ id: '', mediaUrl: '' });
    onClose();
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && canWeUpdatePage) {
            setPage(prevPage => prevPage + 1);
          }
        });
      },
      {
        root: document.querySelector('.audios'),
        rootMargin: '0px',
        threshold: 0.1
      }
    );

    if (weNeedToLoadRef.current) {
      observer.observe(weNeedToLoadRef.current);
    }

    return () => {
      if (weNeedToLoadRef.current) {
        observer.unobserve(weNeedToLoadRef.current);
      }
    };
  }, [activeMenu, canWeUpdatePage]);

  const filteredVoices = voices.filter(voice => {
    const q = searchQuery.toLowerCase();
    const nameMatch = (voice.name || '').toLowerCase().includes(q);
    const genderMatch = (voice.gender || '').toLowerCase().startsWith(q);
    const tagsMatch = voice.tags?.some(tag =>
      (tag || '').toLowerCase().includes(q)
    );
    return nameMatch || genderMatch || !!tagsMatch;
  });

  const getClassNameForReGenerateBtn = () => {
    const normalizeText = (value?: string) => {
      if (!value) return '';
      return value
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\r?\n|\r/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/[^\p{L}\p{N} ]+/gu, '')
        .trim();
    };

    let _newNarration = normalizeText(newNarration?.script);
    const _text = normalizeText(text);

    if (!_newNarration) {
      _newNarration = normalizeText(generatedVoices?.script);
    }
    if (_newNarration != _text) {
      return '';
    }
    return 're_generate_btn';
  };

  return (
    <Container onKeyDown={handlePopupKeyDown}>
      <Popup ref={fileElRef}>
        <Wrapper onKeyDown={handlePopupKeyDown}>
          <CloseButton type="close" onClick={onClose} autoFocus={false} />
          <div className="left" onKeyDown={handlePopupKeyDown}>
            <h3>SELECT YOUR MEDIA</h3>
            <ul>
              {menu.map(item => (
                <li
                  className={`${item.className} ${item.active ? 'active' : ''}`}
                  key={item?.title}
                  onClick={() => {
                    setMenu(
                      menu.map(i => ({
                        ...i,
                        active: i.className == item.className
                      }))
                    );
                    setHasSwitchedToUpload(true); // Reset flag when user manually switches
                  }}
                >
                  {item.title}
                  <ArrowIcon />
                </li>
              ))}
            </ul>
          </div>
          {activeMenu == 'upload' && (
            <div className="right" onKeyDown={handlePopupKeyDown}>
              <h3>File Upload</h3>
              <div>
                <div
                  className="header upload"
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="icon">
                    <UploadAudioIcon />
                  </div>
                  <div className="text">
                    <b>Drop Your Audio Here</b>
                    <p>
                      Upload files up to 20 MB,
                      <br />
                      Accepted file format: MP3
                    </p>
                  </div>
                  <LightButton style={{ width: '145px' }}>
                    <input
                      type="file"
                      accept="audio/mp3"
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                      id="fileInput"
                      disabled={uploading}
                    />
                    <label
                      htmlFor="fileInput"
                      style={{ cursor: 'pointer', display: 'flex' }}
                    >
                      {uploading ? textForUploading : 'Browse file'}
                    </label>
                  </LightButton>
                </div>
              </div>
              {audios && audios.length > 0 && (
                <h3 style={{ paddingBottom: '10px' }}>Recent Uploads</h3>
              )}
              <div className="audios small">
                {audios.map(audio => (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      marginBottom: '10px'
                    }}
                    key={audio.id}
                  >
                    <div className="audio_name">{audio.name || ''}</div>
                    <div key={audio.id} className="audio_item">
                      <audio key={audio.id} controls style={{ height: '48px' }}>
                        {audio.mediaUrl && (
                          <source src={audio.mediaUrl} type="audio/mpeg" />
                        )}
                      </audio>
                      <SmallButton
                        style={{
                          width: '80px',
                          backgroundColor:
                            sequence.narration == audio.mediaUrl
                              ? '#9738FF'
                              : '#9738FF',
                          color: '#fff',
                          fontWeight: '600'
                        }}
                        onClick={() => onSelectNarration(audio)}
                      >
                        {sequence.narration == audio.mediaUrl || id == audio.id
                          ? 'Remove'
                          : 'Apply'}
                      </SmallButton>
                      <LightButton
                        title="Remove"
                        onClick={() => onRemoveAudio(audio.id)}
                        style={{
                          padding: '9px',
                          width: '34px',
                          height: '33px',
                          display: 'block',
                          marginLeft: 'auto',
                          zIndex: 2
                        }}
                      >
                        <TrashIconForBtn
                          style={{ marginLeft: '-5px', marginTop: '-5px' }}
                        />
                      </LightButton>
                    </div>
                  </div>
                ))}
                {loading && <CircleLoader showText={true} />}
                <div className="weNeedToLoad" ref={weNeedToLoadRef}></div>
              </div>
              {audios.length == 0 && (
                <div className="no_results">
                  <NoImageIcon />
                  <p>Recent audio files will appear here</p>
                </div>
              )}
            </div>
          )}
          {activeMenu == 'ai' && (
            <div
              className="right"
              style={{ flex: 1 }}
              onKeyDown={handlePopupKeyDown}
            >
              <div
                className={`ai_container ${
                  !newNarration &&
                  (!generatedVoices || !generatedVoices.voiceId)
                    ? 'without_footer'
                    : ''
                }`}
              >
                <div className="ai_left">
                  <h3>Select a Voice</h3>
                  <div className="search_voice">
                    <input
                      type="text"
                      placeholder="Search voices..."
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                    />
                  </div>
                  <div className="voice_list">
                    {defaultVoice && (
                      <>
                        <div className="voice_list_title">Pinned voice</div>
                        <VoiceItem
                          key={defaultVoice.voiceId || defaultVoice.voice_id}
                          voice={defaultVoice}
                          isSelected={
                            selectedVoice ==
                            (defaultVoice.voiceId || defaultVoice.voice_id)
                          }
                          onSelect={voiceId => setSelectedVoice(voiceId)}
                          apiService={apiService}
                          dontShowDots={true}
                          stopAllAudioPlayersExcept={
                            defaultVoice.voiceId || defaultVoice.voice_id
                              ? stopAllAudioPlayersExcept
                              : undefined
                          }
                          registerAudioPlayer={
                            defaultVoice.voiceId || defaultVoice.voice_id
                              ? registerAudioPlayer
                              : undefined
                          }
                          unregisterAudioPlayer={
                            defaultVoice.voiceId || defaultVoice.voice_id
                              ? unregisterAudioPlayer
                              : undefined
                          }
                        />
                      </>
                    )}
                    {filteredVoices && filteredVoices.length > 0 && (
                      <div className="voice_list_title">All Voices</div>
                    )}
                    {filteredVoices &&
                      filteredVoices.length > 0 &&
                      filteredVoices?.map(voice =>
                        defaultVoice?.voiceId == voice.voiceId ? null : (
                          <VoiceItem
                            key={voice.voiceId || voice.voice_id}
                            voice={voice}
                            isSelected={
                              selectedVoice ===
                              (voice.voiceId || voice.voice_id)
                            }
                            onSelect={voiceId => setSelectedVoice(voiceId)}
                            apiService={apiService}
                            setDefaultVoice={setDefaultVoice}
                            stopAllAudioPlayersExcept={
                              voice.voiceId || voice.voice_id
                                ? stopAllAudioPlayersExcept
                                : undefined
                            }
                            registerAudioPlayer={
                              voice.voiceId || voice.voice_id
                                ? registerAudioPlayer
                                : undefined
                            }
                            unregisterAudioPlayer={
                              voice.voiceId || voice.voice_id
                                ? unregisterAudioPlayer
                                : undefined
                            }
                          />
                        )
                      )}
                  </div>
                </div>
                <div className="ai_right">
                  <h3>Input Narration</h3>
                  <textarea
                    placeholder="Type here"
                    id="narration_input_text"
                    value={text}
                    onChange={e => setText(e.target.value)}
                  />
                  {text &&
                  ((generatedVoices &&
                    generatedVoices.id &&
                    generatedVoices.voiceId) ||
                    (newNarration &&
                      newNarration.voiceId &&
                      newNarration.id)) &&
                  ((newNarration && newNarration.script) ||
                    (generatedVoices && generatedVoices.script)) ? (
                    <LightButton
                      // className={getClassNameForReGenerateBtn()}
                      className={''}
                      onClick={onGenerateNarration}
                    >
                      {generation ? textForBtn : 'Re-generate'}
                    </LightButton>
                  ) : (
                    <LightButton
                      onClick={onGenerateNarration}
                      disabled={
                        loading
                          ? true
                          : generation ||
                            text.length === 0 ||
                            selectedVoice === '' ||
                            disableGenerate
                      }
                    >
                      {generation ? textForBtn : 'Generate Narration'}
                    </LightButton>
                  )}
                </div>
              </div>
              {!loading &&
                ((generatedVoices && generatedVoices.voiceId) ||
                  newNarration) && (
                  <div className="ai_footer">
                    <div className="text">
                      <b>Now playing</b>
                      <p>{newNarration?.name || generatedVoices?.name}</p>
                      <span>
                        by{' '}
                        <b>
                          {getVoiceName(
                            newNarration?.voiceId || generatedVoices?.voiceId
                          )}
                        </b>
                      </span>
                    </div>
                    <div className="audio_preview">
                      {((generatedVoices && generatedVoices.voiceId) ||
                        newNarration) && (
                        <audio key={'audioPreview'} controls>
                          <source
                            src={
                              newNarration?.mediaUrl ||
                              generatedVoices?.mediaUrl
                            }
                            type="audio/mpeg"
                          />
                        </audio>
                      )}
                    </div>
                    {newNarration &&
                      newNarration.voiceId &&
                      newNarration.id != generatedVoices?.id && (
                        <LightButton
                          onClick={() => onSelectNarration(newNarration)}
                        >
                          Apply
                        </LightButton>
                      )}
                    {generatedVoices &&
                      generatedVoices.id &&
                      generatedVoices.voiceId &&
                      !newNarration && (
                        <SmallButton
                          style={{
                            width: '80px',
                            backgroundColor: '#f3ecff',
                            color: '#9738ff'
                          }}
                          onClick={() =>
                            DeselectNarration(Number(generatedVoices.id))
                          }
                        >
                          Remove
                        </SmallButton>
                      )}
                  </div>
                )}
            </div>
          )}
        </Wrapper>
      </Popup>
    </Container>
  );
};

export default NarrationPopup;
